import * as React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useAppProvider } from "../AppContext";
import { Box, Avatar, Button, ListItem, CircularProgress } from "@mui/material";
import { CollectionItem, getNFTItems, NFTItem } from "../api";
import { Virtuoso } from "react-virtuoso";
import Search from "./Search";

interface Cat721ListItemProps {
  item: CollectionItem;
  swap: (collectionItem: CollectionItem, item: NFTItem) => void;
}

export default function Cat721ListItem(props: Cat721ListItemProps) {
  const { connected, network, connectedAccount } = useAppProvider();

  const [open, setOpen] = React.useState(false);

  const [_loading, setLoading] = React.useState(true);

  const [_nftItems, setNftItems] = React.useState<NFTItem[]>([]);

  const [_filter, setFilter] = React.useState<string>("");

  React.useEffect(() => {
    if (open && connected() && connectedAccount) {
      setLoading(true);
      getNFTItems(
        network,
        connectedAccount.payment.address,
        props.item.collectionId
      ).then((items) => {
        setNftItems(items);
        setLoading(false);
      })
      .catch((e) => {
        console.error("getNFTItems error", e);
        setLoading(false);
      });
    }
  }, [open, connected, connectedAccount, network, props.item.collectionId]);

  const handleClick = () => {
    setOpen(!open);
  };

  const filterednftItems = _filter
    ? _nftItems.filter((item) => item.localId.toString().includes(_filter))
    : _nftItems;
  const height = Math.min(1000, 80 * filterednftItems.length);

  return (
    <Box>
      <ListItemButton onClick={handleClick}>
        <ListItemText
          sx={{ width: 100 }}
          primary={`${props.item.symbol}`}
          secondary={
            props.item.collectionId.substring(0, 4) +
            "..." +
            props.item.collectionId.substring(
              props.item.collectionId.length - 8
            )
          }
          primaryTypographyProps={{
            title: props.item.metadata.description || props.item.symbol,
            sx: {
              width: 90,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          }}
          secondaryTypographyProps={{ title: props.item.collectionId }}
        />
        <ListItemText
          sx={{ width: 160 }}
          primary={`v1 balance: ${props.item.confirmed}`}
          primaryTypographyProps={{
            sx: {
              width: 150,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          }}
          secondary={`v2 balance: ${props.item.collection2Confirmed}`}
          secondaryTypographyProps={{
            sx: {
              width: 150,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          }}
        />
        {open ? (
          <Search
            filter={(filter) => {
              setFilter(filter);
            }}
          />
        ) : (
          <></>
        )}

        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {!_loading ? (
          <Virtuoso
            style={{ height: Math.max(height, 100) }}
            totalCount={Math.max(1, filterednftItems.length)}
            itemContent={(index) => {
              const item = filterednftItems[index];

              if (!item) {
                return (
                  <ListItem sx={{  }} key={"no-item"}>
                    <ListItemText primary={`No nfts`} />
                  </ListItem>
                );
              }
              return (
                <ListItem sx={{ pl: 1 }} key={item.localId}>
                  <ListItemIcon>
                    <Avatar src={item.url} style={{ width: 40, height: 40 }} />
                  </ListItemIcon>
                  <ListItemText primary={`localId: ${item.localId}`} />
                  <Button
                    variant="outlined"
                    onClick={() => {
                      props.swap(props.item, item);
                    }}
                  >
                    upgrade
                  </Button>
                </ListItem>
              );
            }}
          />
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress sx={{ mt: 1 }} />
          </Box>
        )}
      </Collapse>
    </Box>
  );
}
